

export let colors = {
    main: "#A675FF",
    gray500: "#6B7280",
    gray600: "#4B5563",
    red500: "#EF4444",
    gray100: "#F3F4F6",
    gray200: "#E5E7EB",
    gray50: "#F9FAFB",
    neutral900: "#1C1819",
    neutral800: "#292524"
}